<template>
    <div class="wrapper">
        <div class="main-panel">
            <div class="main-content">
                <div class="content-wrapper">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="px-3">
                                            <h2>{{ $t("labels.patientReport") }}</h2>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="startDate">{{ $t("labels.startDate") }}</label>
                                                        <date-picker v-model="filters.startDate" width="100%" format="DD/MM/YYYY" :lang="$i18n.locale"></date-picker>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="endDate">{{ $t("labels.endDate") }}</label>
                                                        <date-picker v-model="filters.endDate" width="100%" format="DD/MM/YYYY" :lang="$i18n.locale"></date-picker>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <a href="" class="btn btn-success" @click.prevent="getPatientReport">{{ $t("labels.search") }}</a>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="px-3 py-3">
                                                        <div class="media">
                                                        <div class="media-body text-left align-self-center">
                                                            <i class="icon-graph success font-large-2 float-left"></i>
                                                        </div>
                                                        <div class="media-body text-right">
                                                            <h3>{{ patients.length }}</h3>
                                                            <span>{{ $t("labels.allPatients") }}</span>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="px-3 py-3">
                                                        <div class="media">
                                                        <div class="media-body text-left align-self-center">
                                                            <i class="icon-graph success font-large-2 float-left"></i>
                                                        </div>
                                                        <div class="media-body text-right">
                                                            <h3>{{ fromWeb }}</h3>
                                                            <span>{{ $t("labels.fromWeb") }}</span>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4"> 
                                                    <div class="px-3 py-3">
                                                        <div class="media">
                                                        <div class="media-body text-left align-self-center">
                                                            <i class="icon-graph success font-large-2 float-left"></i>
                                                        </div>
                                                        <div class="media-body text-right">
                                                            <h3>{{ fromMobile }}</h3>
                                                            <span>{{ $t("labels.fromMobile") }}</span>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row bottom-space">
                                                <div class="col-md-4"> 
                                                    <div class="px-3 py-3">
                                                        <div class="media">
                                                        <div class="media-body text-left align-self-center">
                                                            <i class="icon-graph success font-large-2 float-left"></i>
                                                        </div>
                                                        <div class="media-body text-right">
                                                            <h3>{{ mobileActivity }}</h3>
                                                            <span>{{ $t("labels.mobileActivity") }}</span>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4"> 
                                                    <div class="px-3 py-3">
                                                        <div class="media">
                                                        <div class="media-body text-left align-self-center">
                                                            <i class="icon-graph success font-large-2 float-left"></i>
                                                        </div>
                                                        <div class="media-body text-right">
                                                            <h3>{{ webActivity }}</h3>
                                                            <span>{{ $t("labels.webActivity") }}</span>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4"> 
                                                    <div class="px-3 py-3">
                                                        <div class="media">
                                                        <div class="media-body text-left align-self-center">
                                                            <i class="icon-graph success font-large-2 float-left"></i>
                                                        </div>
                                                        <div class="media-body text-right">
                                                            <h3>{{ averageAge }}</h3>
                                                            <span>{{ $t("labels.ageAverage") }}</span>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <table class="table">
                                                        <thead>
                                                            <th>
                                                                {{ $t("labels.nation") }}
                                                            </th>
                                                            <th>
                                                                {{ $t("labels.userCount") }}
                                                            </th>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="nation in nations" :key="nation.nation">
                                                                <td>
                                                                    {{ nation.nation === undefined ? "Not set" : nation.nation }}
                                                                </td>
                                                                <td>
                                                                    {{ nation.count }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import PatientService from '@/services/patient'
import StatisticsService from '@/services/statistics'
import _ from 'lodash'

export default {
    data() {
        return {
            patients: [],
            nations: [],
            mobileActivity: 0,
            webActivity: 0,
            averageAge: 0,
            filters: {
                startDate: moment(new Date()).startOf('month').format('YYYY-MM-DD'),
                endDate: moment(new Date()).endOf('month').format('YYYY-MM-DD')
            }
        }
    },
    computed: {
        fromMobile() {
            let mobile = this.patients.filter(function (u) {
                return u.source === 'mobile'
            })
            return mobile.length
        },
        fromWeb() {
            let web = this.patients.filter(function (u) {
                return u.source === 'web'
            }) 
            return web.length
        }
    },
    methods: {
        getPatients: async function () {
            let result = await PatientService.patientStats(this.filters)
            if (result) {
                this.patients = result.data
                let nations = [...new Set(this.patients.map(u => u.country))]
                let nationElements = []
                for (let n in nations) {
                    let currentNationUsers = result.data.filter(function (u) {
                        return u.language === nations[n]
                    })
                    let current = {
                        nation: nations[n],
                        count: currentNationUsers.length
                    }
                    nationElements.push(current)
                }
                this.nations = nationElements
                let ages = this.patients.map(p => moment().diff(moment(p.birthDate, 'YYYYMMDD'), 'years'))
                this.averageAge = _.sum(ages) / ages.length
            }
        },
        getPatientReport: async function() {
            await this.getPatients()
            await this.getWebActivity()
            await this.getMobileActivity()
        },
        getWebActivity: async function () {
            let filters = {
                source: 'web',
                startDate: moment(new Date()).startOf('month').format('YYYY-MM-DD'),
                endDate: moment(new Date()).endOf('month').format('YYYY-MM-DD')
            }
            let result = await StatisticsService.getActivity(filters)
            if (result) {
                this.webActivity = result.data.length
            }
        },
        getMobileActivity: async function () {
            let filters = {
                source: 'mobile',
                startDate: moment(new Date()).startOf('month').format('YYYY-MM-DD'),
                endDate: moment(new Date()).endOf('month').format('YYYY-MM-DD')
            }
            let result = await StatisticsService.getActivity(filters)
            if (result) {
                this.mobileActivity = result.data.length
            }
        }
    },
    mounted: async function () {
        await this.getPatients()
        await this.getWebActivity()
        await this.getMobileActivity()
    }
}
</script>

<style lang="scss">
    .px-3 {
        padding: 15px 0 15px 0;
    }
    .py-3 {
        border: 1px solid #ccc;
        border-radius: 10px;
        margin-bottom: 15px;
    }
</style>


